module.exports = __webpack_public_path__ + "static/CookieRun-Bold.subset-1e10aa4f6c7706b36b7a9a2dd12fe109.otf";